// Copyright (c) 2016 Deere & Company

import TransferEnterAor from '@deere/cps-it.warranty-model-factory/lib/transfer-enter-aor';
import t from 'tcomb';

const Transfers = t.list(TransferEnterAor, 'Transfers');

export const getDefaultState = () => new Transfers([]);

export default Transfers;



// WEBPACK FOOTER //
// ./src/product/transfers/state/transfers.js